/* eslint-disable max-len */
import { getMessage } from '../../translations';
import { getUserFromLocalStorage } from '../../component/utils/user';
const userLang = getUserFromLocalStorage();
const languageCode = userLang?.language?.toLowerCase().startsWith('en') ? 'en' : userLang?.language?.toLowerCase() || 'default-language';

export const getLoadingsImporterSetting = ({ 
  dropdownData,
  conditioningDropdownData,
}) => ({
  //multipleFileUpload: true,
  developerMode: false,
  identifier: 'loadings',
  language: languageCode,
  disableTemplates: true,
  allowManualInput: false,
  numberFormat: "us",
  processingEngine:"node",
  inputTypes:["csv", "tsv", "xls", "xlsx","pdf"],
  i18nOverrides: {
    txt_back_page_dialog: getMessage("If you press the \"Go back\" button, you will lose the progress of the current step."),
    txt_close_page_modal: getMessage("If you press the \"Go back\" button, you will lose the entire progress of all steps."),
    txt_confirm_submit_data_with_error: getMessage("Are you sure you want to submit your data? Rows with an error won't be imported. If yes, please use the “Submit” button. Otherwise, press the “Back” button"),
    txt_confirm_submit_data_without_error: getMessage("Are you sure you want to submit your data? If yes, please use the “Submit” button. Otherwise, press the “Back” button"),
    txt_allow_error_confirm_submit_data_with_error: getMessage("Are you sure you want to submit your data? Rows with an error will be imported as well. If yes, please use the “Submit” button. Otherwise, press the “Back” button"),
    txt_import_data_error_exceed: getMessage("Your import resulted in {{error}} errors. If you want to correct these errors inside the application, press the “Continue” button. Otherwise, you could download the merged table as Excel (.xlsx) by pressing the “Export as Excel” button."),
  },
  columns: [
    {
      key: 'qualityName',
      label: getMessage("MATERIAL"),
      description: getMessage("The commodity or quality name"),
      example: "HMS 1/2",
      columnType: 'category',
      alternativeMatches: ['Material', 'Produit', 'produit', 'Commodity Name', 'Nom du produit'],
      // dropdownOptions: dropdownData,
      dropdownOptions: Array.isArray(dropdownData) ? dropdownData : [],
      validations: [
        {
          validate: 'required',
          errorMessage: getMessage('The material name cannot be blank'),
        },
      ],
      isMultiSelect: false,
    },
    {
      key: 'harold_number',
      label: getMessage('Jules number'),
      description: getMessage('System number for truck or container (Jules)'),
      example: 'CT2023-08-0001111',
      columnType: 'string',
      validations: [
        {
          validate: 'required',
        },
      ],
      alternativeMatches: [
        'Container Ref',
        'ContainerReference',
        'Container ref.',
        'Libelle',
        'libelle',
        'Jules container',
        'camion no',
      ],
    },
    {
      key: 'quantityQuantity',
      label: getMessage('Net Weight'),
      description: getMessage('Quantity of material in delivery'),
      example: '19,335',
      columnType: 'float',
      numberFormat: 'us',
      alternativeMatches: ['Quantity', 'Amount', 'Net', 'Poids', 'poids', 'Poids net'],
      validations: [
        {
          validate: 'required',
          errorMessage: getMessage('Quantity cannot be left blank'),
        },
      ],
    },
    {
      key: 'dateOfLoading',
      label: getMessage('Date of loading'),
      description: getMessage('Date of loading'),
      example: '2023-07-22T15:52:45.175Z',
      columnType: 'date',
      alternativeMatches: ['Date', 'Delivery date', 'DATE DE', 'date de chargement'],
      outputFormat: 'MM/DD/YYYY',
      validations: [
        {
          validate: 'required',
          errorMessage: getMessage('Date of loading cannot be left blank'),
        },
      ],
    },
    {
      key: 'referenceNumber',
      label: getMessage('Container / Truck number'),
      description: getMessage('Container reference number'),
      example: 'DM31345',
      columnType: 'string',
      alternativeMatches: [
        'ID',
        'Container reference number',
        'reference ID',
        'referenceId',
        'Container number',
        'Vehicule',
        'vehicule',
        'N° DE TRACTEUR',
      ],
    },
    {
      key: 'erpContainerId',
      label: getMessage('ERP container ID'),
      description: getMessage('ERP Container ID'),
      example: 'BG921AY',
      columnType: 'string',
      hidden: true,
      alternativeMatches: [
        'ERP ID',
        'ERP reference number',
        'ERP container number',
        'ERP Container ID',
      ],
    },
    {
      key: 'grossQuantityQuantity',
      label: getMessage('Gross Weight'),
      columnType: 'float',
      numberFormat: 'us',
      alternativeMatches: [
        'Poids brut',
      ],
    },
    {
      key: 'sterileQuantity',
      label: getMessage('Sterile Weight'),
      columnType: 'float',
      numberFormat: 'us',
      alternativeMatches: [
        'Sterile Weight',
        'Sterile weight',
        'Poids stérile',
        'Poids dechets',
        'POIDS DECHETS',
      ],
    },
    {
      key: 'sterileGrossQuantity',
      label: getMessage('Sterile Gross Weight'),
      columnType: 'float',
      numberFormat: 'us',
      alternativeMatches: [
        'Sterile Gross Weight',
        'Sterile gross weight',
        'Poids brut stérile',
      ],
    },
    {
      key: 'generalComment',
      label: getMessage('General comment'),
      columnType: 'string',
    },
    {
      key: 'loadingComment',
      label: getMessage('Loading comment'),
      columnType: 'string',
    },
    {
      key: 'deliveryComment',
      label: getMessage('Delivery comment'),
      columnType: 'string',
    },
    {
      key: 'quantityUnit',
      label: getMessage('Packages'),
      columnType: 'float',
      numberFormat: 'us',
      alternativeMatches: ['Packages', 'packages', "Quantité d'emballage"],
    },
    {
      key: 'buyOperationId',
      label: getMessage('Buy operation id'),
      description: getMessage('Buy operation id'),
      example: '289',
      columnType: 'int',
      numberFormat: 'us',
      hidden: true,
    },
    {
      key: 'sellOperationId',
      label: getMessage('Sell operation id'),
      description: getMessage('Sell operation id'),
      example: '289',
      columnType: 'int',
      numberFormat: 'us',
      hidden: true,
    },
    {
      key: 'containerOperationQualityId',
      label: getMessage('Container operation quality id'),
      description: getMessage('Container operation quality id'),
      example: '289',
      columnType: 'int',
      numberFormat: 'us',
      hidden: true,
    },
    {
      key: 'maximumGrossWeight',
      label: getMessage('MGW'),
      columnType: 'float',
      numberFormat: 'us',
    },
    {
      key: 'tareWeight',
      label: getMessage('Tare Weight'),
      columnType: 'float',
      numberFormat: 'us',
      alternativeMatches: [
        'TARE SURVEYFERT',
        'Container Tare Weight',
      ],
    },
    {
      key: 'packages',
      label: getMessage('Packing type'),
      description: getMessage('Packing type'),
      example: 'CIF',
      columnType: 'category',
      // dropdownOptions: conditioningDropdownData,
      dropdownOptions: Array.isArray(conditioningDropdownData) ? conditioningDropdownData : [],
      isMultiSelect: false,
      alternativeMatches: ['conditionning','packing','Packing type','type'],
    },

    {
      key: 'weightUnit',
      label: getMessage('Weight unit'),
      columnType: 'string',
    },
    {
      key: 'qualityId',
      label: getMessage('Material ID'),
      description: getMessage("The ID linked to the quality name"),
      example: '865',
      columnType: 'int',
      numberFormat: 'us',
      hidden: true,
    },
    {
      key: 'sealedNumber',
      label: getMessage('Seal number'),
      description: getMessage('Container seal number'),
      example: '3009351',
      columnType: 'string',
      alternativeMatches: ['Seal number', 'sealedNumber', "Numéro de scellé"],
    },
    {
      key: 'thicknessQuantity',
      label: getMessage('Thickness'),
      columnType: 'float',
      numberFormat: 'us',
      alternativeMatches: ['Thickness'],
    },
    {
      key: 'thicknessUnit',
      label: getMessage('Unit (thickness)'),
      columnType: 'string',
      alternativeMatches: ['Unit (thickness)'],
    },
    {
      key: 'lengthQuantity',
      label: getMessage('Length'),
      columnType: 'float',
      numberFormat: 'us',
      alternativeMatches: ['Length'],
    },
    {
      key: 'lengthUnit',
      label: getMessage('Unit (length)'),
      columnType: 'string',
      alternativeMatches: ['Unit (length)'],
    },
    {
      key: 'widthQuantity',
      label: getMessage('Width'),
      columnType: 'float',
      numberFormat: 'us',
      alternativeMatches: ['Width'],
    },
    {
      key: 'widthUnit',
      label: getMessage('Unit (width)'),
      columnType: 'string',
      alternativeMatches: ['Unit (width)'],
    },
    {
      key: 'heightQuantity',
      label: getMessage('Height'),
      columnType: 'float',
      numberFormat: 'us',
      alternativeMatches: ['Height'],
    },
    {
      key: 'heightUnit',
      label: getMessage('Unit (height)'),
      columnType: 'string',
      alternativeMatches: ['Unit (height)'],
    },
    {
      key: 'dimensionUserUnit',
      label: getMessage('Unit (dimensions)'),
      columnType: 'string',
      alternativeMatches: ['Unit (dimensions)','Unit for Height'],
    },
    {
      key: 'loadingType',
      label: getMessage('User loading type'),
      columnType: 'string',
    },
    {
      key: 'packageReference',
      label: getMessage('Package Reference'),
      columnType: 'string',
      alternativeMatches: ['Package Reference','Supplier Reference'],
    },
    {
      key: 'operationQualityId',
      label: getMessage('Operation quality id'),
      description: getMessage('Operation quality id'),
      example: '289',
      columnType: 'int',
      numberFormat: 'us',
      hidden: true,
    },
  ],
});